import { render } from "./404.vue?vue&type=template&id=12f3cc1c"
const script = {}
script.render = render

export default script